<template>
  <div class="financial-notification-activity-list page page-with-table p-2">
    <page-header class="mb-2">
      <template v-slot:title>
        <div style="flex: 1">
          <h1 class="mb-0">{{ $t('Notification Activity') }}</h1>
        </div>
      </template>
    </page-header>
    <div class="card content-wrapper">
      <notification-activity-table/>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import PageHeader from "@/core/components/page-header/PageHeader";
  import NotificationActivityTable from "@/modules/notification-activity/NotificationActivityTable";

  const {mapActions} = createNamespacedHelpers('notificationActivity');

  export default {
    name: "NotificationActivity",
    components: {NotificationActivityTable, PageHeader},
    methods: {
      ...mapActions(['updateTableSource']),
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'notificationActivity',
        extraFilters: {actions: ''},
      });
    },
  }
</script>

<style scoped lang="scss">
  @import "./scss/variables.scss";

  .financial-notification-activity-list {
    @include list-view-wrapper;
  }
</style>
